module.exports = {

    viewType: {
        ACTION_REQUIRED:    "action-required",
        ASSIGNED_TO_ME:     "assigned-to-me",
        ALL_INVOLVED:       "all-involved",
        CREATED_BY_ME:      "created-by-me",
        SOMEDAY:            "someday",
        PASTDUE:            "pastdue",
    },

    paramName: {
        'action-required':  'actionRequired',
        'assigned-to-me':   'assignedToMe',
        'all-involved':     'allInvolved',
        'created-by-me':    'createdByMe',
        'someday':          'someday',
        'pastdue':          'pastdue',
    }
};
